export enum ISubscriptionResourceEnum{
  ACL = 'ACL',
  ANDCARDS_INTEGRATION = 'ANDCARDS_INTEGRATION',
  APPCRUE_INTEGRATION = 'APPCRUE_INTEGRATION',
  AUTH0_INTEGRATION = 'AUTH0_INTEGRATION',
  BIG_DATA_ANALYTICS = 'BIG_DATA_ANALYTICS',
  BOOKEY = 'BOOKEY',
  CAPACITY_MANAGEMENT = 'CAPACITY_MANAGEMENT',
  CHAINELS_INTEGRATION = 'CHAINELS_INTEGRATION',
  CLOUDBEDS_INTEGRATION = 'CLOUDBEDS_INTEGRATION',
  COBOT_INTEGRATION = 'COBOT_INTEGRATION',
  COMMUNICATIONS = 'COMMUNICATIONS',
  COSOFT_FR_INTEGRATION = 'COSOFT_FR_INTEGRATION',
  CUSTOM_FIELDS = 'CUSTOM_FIELDS',
  CUSTOM_MOBILE_APP = 'CUSTOM_MOBILE_APP',
  CUSTOM_PRIVACY_SETTINGS = 'CUSTOM_PRIVACY_SETTINGS',
  CUSTOM_TABLES = 'CUSTOM_TABLES',
  CUSTOM_TABLES_MEDIUM = 'CUSTOM_TABLES_MEDIUM',
  CUSTOM_TABLES_SMALL = 'CUSTOM_TABLES_SMALL',
  DOMAIN = 'DOMAIN',
  DUVE_INTEGRATION = 'DUVE_INTEGRATION',
  EAGLE_EYE_CAMERAS_PLUGIN = 'EAGLE_EYE_CAMERAS_PLUGIN',
  ELEVATOR_CONTROL = 'ELEVATOR_CONTROL',
  EXTENDED_SUPPORT = 'EXTENDED_SUPPORT',
  EXTRA_DOMAIN = 'EXTRA_DOMAIN',
  F9000 = 'F9000',
  FARNETWORK_INTEGRATION = 'FARNETWORK_INTEGRATION',
  FLEXIPASS_INTEGRATION = 'FLEXIPASS_INTEGRATION',
  FLUIDA_INTEGRATION = 'FLUIDA_INTEGRATION',
  GOOGLE_SSO = 'GOOGLE_SSO',
  HP_RFIDEAS_INTEGRATION = 'HP_RFIDEAS_INTEGRATION',
  HYPERBRIDGE_INTEGRATION = 'HYPERBRIDGE_INTEGRATION',
  HYPERSENSOR_DS_ADDON = 'HYPERSENSOR_DS_ADDON',
  HYPERTOUCH_MANAGEMENT = 'HYPERTOUCH_MANAGEMENT',
  INVITATIONS = 'INVITATIONS',
  LOCKS = 'LOCKS',
  MAIL_DNS = 'MAIL_DNS',
  MEWS_INTEGRATION = 'MEWS_INTEGRATION',
  MKS_MANAGEMENT = 'MKS_MANAGEMENT',
  MOBILE_APP_ENGINE = 'MOBILE_APP_ENGINE',
  MULTI_SITE = 'MULTI_SITE',
  MULTI_TENANT = 'MULTI_TENANT',
  NEXUDUS_INTEGRATION = 'NEXUDUS_INTEGRATION',
  NIBOL_INTEGRATION = 'NIBOL_INTEGRATION',
  OCTORATE_INTEGRATION = 'OCTORATE_INTEGRATION',
  OFFICERND_INTEGRATION = 'OFFICERND_INTEGRATION',
  OFFICE_SSO = 'OFFICE_SSO',
  OPERTO_INTEGRATION = 'OPERTO_INTEGRATION',
  OPTIX_INTEGRATION = 'OPTIX_INTEGRATION',
  PARCEL_MANAGEMENT = 'PARCEL_MANAGEMENT',
  PEOPLELINK_INTEGRATION = 'PEOPLELINK_INTEGRATION',
  PIN_SHARING_DELIVERY = 'PIN_SHARING_DELIVERY',
  PLANET_INTEGRATION = 'PLANET_INTEGRATION',
  PRIVATE_UNITS_MANAGEMENT = 'PRIVATE_UNITS_MANAGEMENT',
  REGISTRY = 'REGISTRY',
  RES_HARMONICS_INTEGRATION = 'RES_HARMONICS_INTEGRATION',
  ROOMRACCOON_INTEGRATION = 'ROOMRACCOON_INTEGRATION',
  SAML_SSO = 'SAML_SSO',
  STANDARD_SUPPORT = 'STANDARD_SUPPORT',
  STRATEGIC_BIM_INTEGRATION = 'STRATEGIC_BIM_INTEGRATION',
  TENUP_INTEGRATION = 'TENUP_INTEGRATION',
  TICKETING_MANAGEMENT = 'TICKETING_MANAGEMENT',
  TITIRO_INTEGRATION = 'TITIRO_INTEGRATION',
  TOPLIFE_INTEGRATION = 'TOPLIFE_INTEGRATION',
  USERS = 'USERS',
  V364 = 'V364',
  V364_BASE = 'V364_BASE',
  VIRTUAL_INTERCOM_MANAGEMENT = 'VIRTUAL_INTERCOM_MANAGEMENT',
  VIRTUAL_INTERCOM_MANAGEMENT_CHECKIN = 'VIRTUAL_INTERCOM_MANAGEMENT_CHECKIN',
  VIRTUAL_INTERCOM_MANAGEMENT_VIDEO = 'VIRTUAL_INTERCOM_MANAGEMENT_VIDEO',
  VIRTUAL_INTERCOM_MANAGEMENT_VOICE = 'VIRTUAL_INTERCOM_MANAGEMENT_VOICE',
  VISITORS_MANAGEMENT = 'VISITORS_MANAGEMENT',
  WEB_API = 'WEB_API',
  WITCO_INTEGRATION = 'WITCO_INTEGRATION',
  ZAPFLOOR_INTEGRATION = 'ZAPFLOOR_INTEGRATION',
}
